import { moreTransactionIsValid } from "services/sosInventoryService/moreTransaction/isValid";
import { quantitySerialsIsValid } from "services/utility/isValid";

export function isValid(record, relatedRecords, lines) {
  let errors = moreTransactionIsValid(record, relatedRecords, lines);
  errors = quantitySerialsIsValid(errors, lines, record.autoSerialLotNumbering);
  return errors;
}
